import React, { useCallback, useEffect, useState } from 'react';
import { ExpandLessIcon } from '../icons/icons';
import style from './scrollToTopButton.module.scss';

const SCROLL_THRESHOLD = 1;

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > SCROLL_THRESHOLD);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
  }, []);

  return (
    <button
      type="button"
      className={`${style.button} ${visible ? style.buttonVisible : ''}`.trim()}
      onClick={scrollToTop}
      aria-label="Scroll to top"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      <ExpandLessIcon className={style.icon} aria-hidden />
    </button>
  );
}
